import { axiosInstance } from 'helper/axiosHelper';
import apiUrls from 'apis/apiUrls';

const authService = {
  login: (data: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.login,
      data,
      config: {
        headers: {
          portal: 'CLIENT',
        },
      },
    });
  },

  logout: (token) => {
    return axiosInstance.makePostRequest({
      url: `${apiUrls.logout}?token=${token}`,
    });
  },

  resetPassword: (data) => {
    return axiosInstance.makePutRequest({
      url: apiUrls.resetPassword,
      config: { headers: { authorization: '' } },
      data,
    });
  },

  checkResetPasswordSessionToken: (data: { sessionToken: string }) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.checkResetPasswordSessionToken,
      data,
    });
  },

  forgotPassword: (data) => {
    return axiosInstance.makePutRequest({
      url: apiUrls.forgotPassword,
      data: { username: data.username, portal: 'CLIENT' },
      config: { headers: { authorization: '' } },
    });
  },

  refreshToken: (data: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.refreshToken,
      data,
      config: {
        headers: {
          portal: 'CLIENT',
        },
      },
    });
  },
};

export default authService;
